/*
 * File: InsuranceAndGuarantorsPage.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Landing page for insurance and guarantors
 */
import React from "react";
import InsuranceAndGuarantorsLinks from "./InsuranceAndGuarantorsLinks";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PatientChart from "services/patients/topofthechart/PatientChart";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-2.5),
    marginTop: theme.spacing(2.5)
  }
});

const InsuranceAndGuarantorsPage = ({ classes }) => {
  return (
    <React.Fragment>
      <PatientChart />
      <Toolbar className={classes.toolbar}>
        <MainHeader pageTitle="Insurance & Guarantors" pageSubtitle="Patient" />
      </Toolbar>
      <InsuranceAndGuarantorsLinks />
    </React.Fragment>
  );
};

InsuranceAndGuarantorsPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(InsuranceAndGuarantorsPage);
